/* Teeinblue Igen/Nem upsell mezők egyetlen jelölőnégyzetként.
   A Teeinblue-ban továbbra is két opció van; mi csak az „Igen”-t mutatjuk,
   és újrakattintásra a rejtett „Nem”-et választjuk. Alapból „Nem” van kiválasztva. */
(function () {
  if (window.__teeUpsellCheckbox) return;
  window.__teeUpsellCheckbox = true;

  function labelText(radio) {
    var l = radio && radio.querySelector('.tee-radio-label');
    return l ? l.textContent.trim().toLowerCase() : '';
  }

  function isYesNo(field) {
    var radios = field.querySelectorAll(':scope > .tee-field__input > .tee-row > .tee-radio');
    return radios.length === 2 && labelText(radios[0]) === 'igen' && labelText(radios[1]) === 'nem';
  }

  function radios(field) {
    return field.querySelectorAll(':scope > .tee-field__input > .tee-row > .tee-radio');
  }

  function isActive(radio) {
    var input = radio.querySelector('input');
    return radio.classList.contains('active') || !!(input && input.checked);
  }

  var busy = false;
  function choose(radio) {
    var label = radio.querySelector('.tee-radio-label') || radio.querySelector('input');
    if (!label) return;
    busy = true;
    try { label.click(); } finally { busy = false; }
  }

  /* Felár a mező címe mellett, az upsell színében. Az ár a Téma beállítások → Upsell árak
     értéke (window.emlekUpsellPrices, típus szerint); ha ott nincs, a címben lévő „+990 Ft”. */
  var PRICE = /\+\s?[\d.\s]+\s?Ft/;
  function fmtPrice(n) {
    return '+' + String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' Ft';
  }
  function configuredPrice(field) {
    var prices = window.emlekUpsellPrices || {};
    for (var i = 0; i < KINDS.length; i++) {
      var n = prices[KINDS[i][0]];
      if (field.classList.contains(KINDS[i][0]) && typeof n === 'number' && n > 0) return fmtPrice(n);
    }
    return '';
  }
  function wrapPrice(field) {
    var span = field.querySelector(':scope > .tee-field__header .tee-field__heading > span:first-child');
    if (!span) return;
    var wanted = configuredPrice(field);
    var badge = span.querySelector('.tee-upsell-price');
    if (badge) {
      if (wanted && badge.textContent !== wanted) badge.textContent = wanted;
      return;
    }
    var found = Array.prototype.some.call(span.childNodes, function (node) {
      if (node.nodeType !== 3) return false;
      var m = node.nodeValue.match(PRICE);
      if (!m) return false;
      var after = node.splitText(m.index);
      after.splitText(m[0].length);
      badge = document.createElement('span');
      badge.className = 'tee-upsell-price';
      badge.textContent = wanted || m[0].replace(/^\+\s?/, '+').trim();
      after.parentNode.replaceChild(badge, after);
      return true;
    });
    if (!found && wanted) {
      badge = document.createElement('span');
      badge.className = 'tee-upsell-price';
      badge.textContent = wanted;
      span.appendChild(document.createTextNode(' '));
      span.appendChild(badge);
    }
  }

  /* A pipa állapota osztályként is: akkor is látszik, ha az „Igen”-t
     máshonnan (pl. a „Kérem az expresszt” gombbal) választották ki */
  function sync() {
    document.querySelectorAll('.tee-upsell-checkbox').forEach(function (field, i) {
      field.classList.toggle('is-checked', isActive(radios(field)[0]));
      /* az első upsell fölé kerül a „Kérhető extrák” felirat */
      field.classList.toggle('tee-upsell-first', i === 0);
    });
  }

  /* Okosposzter választók: típus szerint jelöljük őket, hogy ikont kaphassanak */
  function tagOkos() {
    document.querySelectorAll(':is(#teeFormInputs, .tee-customization-form) .testclass .tee-radio:not([data-okos])').forEach(function (radio) {
      var t = labelText(radio);
      radio.dataset.okos = /youtube/.test(t) ? 'youtube' : /spotify/.test(t) ? 'spotify' : /saját|fájl|fotó/.test(t) ? 'own' : 'link';
    });
  }

  /* Kiemelt kártyát csak az upsell (Igen/Nem), a kézzel „upsell” osztályt kapott és a
     „Dal kiválasztása” mezők kapnak; a többi kétgombos választó (pl. Látható/Elrejtve) sima marad */
  function isSongChoice(field) {
    var h = field.querySelector(':scope > .tee-field__header .tee-field__heading');
    return /dal kiválasztása/i.test(h ? h.textContent : '');
  }

  /* Upsell típusa a mező címéből, hogy minden terméknél ugyanazt a színt és ikont kapja
     (a CSS korábban csak a referencia termék réteg-azonosítóira volt kötve) */
  var KINDS = [
    ['upsell-expressz', /expressz/i],
    ['upsell-digitalis', /digit/i],
    ['upsell-tores', /törés/i],
    ['upsell-okos', /okos/i]
  ];
  /* Csak ezek upsellek (Gabor): digitális verzió, törésbiztosítás, expressz, Okosposzter.
     Minden más Igen/Nem mező (pl. „Szeretnél saját stáblistát?”) a termék grafikájának
     opciója, az sima választó marad. */
  function kindOf(field) {
    var h = field.querySelector(':scope > .tee-field__header .tee-field__heading');
    var text = h ? h.textContent : '';
    for (var i = 0; i < KINDS.length; i++) {
      if (KINDS[i][1].test(text)) return KINDS[i][0];
    }
    return '';
  }

  function tagKinds() {
    document.querySelectorAll(':is(#teeFormInputs, .tee-customization-form) > .tee-field.tee-upsell-checkbox').forEach(function (field) {
      var h = field.querySelector(':scope > .tee-field__header .tee-field__heading');
      var text = h ? h.textContent : '';
      for (var i = 0; i < KINDS.length; i++) {
        if (KINDS[i][1].test(text)) { field.classList.add(KINDS[i][0]); break; }
      }
    });
  }

  function markCards() {
    document.querySelectorAll(':is(#teeFormInputs, .tee-customization-form) > .tee-field').forEach(function (field) {
      if (field.classList.contains('upsell') && !kindOf(field)) {
        /* kézzel „upsell” osztályt kapott, de nem valódi extra: ne kapjon upsell kinézetet */
        field.classList.remove('upsell');
      }
      if (field.classList.contains('tee-upsell-checkbox') || field.classList.contains('upsell')) {
        field.classList.add('tee-up');
      } else if (radios(field).length === 2 && isSongChoice(field)) {
        field.classList.add('tee-up', 'tee-song-choice');
      }
    });
  }

  function setup() {
    document.querySelectorAll(':is(#teeFormInputs, .tee-customization-form) > .tee-field').forEach(function (field) {
      if (!isYesNo(field) || !kindOf(field)) return;
      /* az osztályt minden körben visszatesszük, mert a Teeinblue újrarajzoláskor lecserélheti */
      field.classList.add('tee-upsell-checkbox');
      tagKinds();
      wrapPrice(field);
      if (field.dataset.upsellCheckbox) return;
      field.dataset.upsellCheckbox = '1';
      var r = radios(field);
      /* Ha még semmi nincs kiválasztva, a „Nem” legyen az alapállapot (a mező kötelező) */
      if (!isActive(r[0]) && !isActive(r[1])) choose(r[1]);
    });
    sync();
    tagKinds();
    tagOkos();
    markCards();
  }

  document.addEventListener('change', sync);
  document.addEventListener('click', function () { setTimeout(sync, 50); });

  /* Kattintás bárhol a kártyán: ki-be kapcsol. Ezt CSS oldja meg natív címkékkel
     (bejelöletlenül az „Igen”, bejelölve a „Nem” címkéje fedi le a kártyát), így a
     Teeinblue valódi felhasználói kattintást kap, és a kosárba is bekerül az opció. */

  var timer;
  new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(setup, 100);
  }).observe(document.documentElement, { subtree: true, childList: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
})();
